export const BRAND_OPTIONS = [
  { code: "GOOD_GOOD_COFFEE", label: "Good Good Coffee" },
  { code: "SHWE_MOE_EAIN_POTATO_CHIPS", label: "Shwe Moe Eain Potato Chips or Vertex Roll On" },
  { code: "RUBY_SAUCES", label: "Ruby Sauces" },
  { code: "FREE_RABBIT_TISSUES", label: "Free Rabbit Tissues" }
] as const;

const BRAND_CODES = new Set<string>(BRAND_OPTIONS.map((brand) => brand.code));

export function validateBrandCodes(values: readonly unknown[]): string[] | null {
  if (values.length < 1 || values.length > BRAND_OPTIONS.length) return null;
  if (values.some((value) => typeof value !== "string" || !BRAND_CODES.has(value))) return null;
  const codes = values as string[];
  if (new Set(codes).size !== codes.length) return null;
  return codes;
}
